import { Injectable } from '@angular/core';
import { SharedDataService } from './shared-data/shared-data.service';
import { MaskedQueryService } from './masked-query.service';

@Injectable({
  providedIn: 'root',
})
export class PlanningHeaderData {
  constructor(private _sharedDataService: SharedDataService, private _maskedQueryService: MaskedQueryService) {}
  selectedMonth: any;
  selectedYear: any;
  selectedDepartment: any;
  selectedDeptData: any;
  selectedPlanningView: any
  storeMonthYear(selYear: any, selDate?: any) {
    const params = this._maskedQueryService.getDecodedHashParams();
      
    if (selDate) {
      params.set('month', selDate.toLocaleString('default', { month: 'long' }));
    }

    params.set('year', selYear.toString());

    this._maskedQueryService.updateEncodedHashParams(params);
  }

  getMonthYear(){
    const params = this._maskedQueryService.getDecodedHashParams();
    if(params?.has('month') || params?.has('year')){
      const yearString = params?.get('year') || ''; // Fallback to empty string
      const year = parseInt(yearString, 10); // Parse year as an integer
      this.selectedYear = year
      if (params?.has('month')) {
        const decodedMonth = (params?.get('month'))
        const monthName = decodedMonth || ''; // Fallback to empty string
        const month = new Date(`${monthName} 1`).getMonth() + 1; // Month in numeric format
        this.selectedMonth = month;
        this._sharedDataService.selDateInPlanning = new Date(
          year,
          month - 1,
          1
        );
      }

      // Update sharedDataService with URL values
    }
    else {
      // Reset values if no URL params are found
      this.selectedMonth = null;
      this.selectedYear = null;
    }
    return { month: this.selectedMonth, year: this.selectedYear };
  }

  storeDepartment(departmentId: any) {
    const params = this._maskedQueryService.getDecodedHashParams();

    if (departmentId) {
      params.set('department', departmentId);
    } else {
      params.delete('department');
    }

    this._maskedQueryService.updateEncodedHashParams(params);
  }
  getDepartment(deptList:any){
    const params = this._maskedQueryService.getDecodedHashParams();
    if(params?.has('department')){
        const departmentIdFromUrl = params?.get('department');
        const decodedDeptId = (departmentIdFromUrl)
        const matchedDept = deptList.find(
          (dept: any) => dept.id === decodedDeptId
        );

        if (matchedDept) {
          this.selectedDepartment = matchedDept.id;
          this.selectedDeptData = matchedDept;
        } else {
          this.selectedDepartment = null; // Handle case where department ID is invalid
        }
    }
    return { id: this.selectedDepartment, data: this.selectedDeptData };
  }

  storePlanningView(planningView: any){
    const params = this._maskedQueryService.getDecodedHashParams();
    if (planningView) {
      params.set('planningView', planningView);
    } else {
      params.delete('planningView');
    }

    this._maskedQueryService.updateEncodedHashParams(params);
  }

  getPlanningView(){
    const params = this._maskedQueryService.getDecodedHashParams();
      if (params?.has('planningView')) {
        const decodedPlanningView = (params?.get('planningView'))
        // const planningViewFromUrl = searchParams.get('planningView');
        const planningViewFromUrl = decodedPlanningView;
        this.selectedPlanningView = planningViewFromUrl;
      }
      return this.selectedPlanningView ;
  }

//remove the commented code later
 // storeMonthYear(selYear: any, selDate?: any) {
  //   // code to add month year to url param starts
  //   // Add month and year to the window URL
  //   const url = new URL(window.location.href);
  //   const hashPath = url.hash.split('?')[0]; // Preserve base hash path
  //   const hashParams = new URLSearchParams(url.hash.split('?')[1]);

  //   // Update month and year in the hash parameters
  //   if (selDate) {
  //     const encodedMonth = this._maskedQueryService.encodeParams(selDate.toLocaleString('default', { month: 'long' }));
  //     // hashParams.set('month', encodedMonth);
  //     hashParams.set(
  //       'month',
  //       selDate.toLocaleString('default', { month: 'long' })
  //     );
  //   }
  //   hashParams.set('year', selYear.toString());
  //   const encodedYear = this._maskedQueryService.encodeParams(selYear.toString());
  //   // hashParams.set('year', encodedYear);
  //   // Reconstruct the hash and update the URL
  //   const newHash = `${hashPath}?${hashParams.toString()}`;
  //   url.hash = newHash;

  //   window.history.replaceState({}, '', url.toString());
  //   // code to add month year to url param ends
  // }

  // getMonthYear() {
  //   // set the month and year from url if the url contains the same.else take the value from shared data service
  //   // Parse month and year from the URL if present
  //   const url = new URL(window.location.href);
  //   const hashParams = new URLSearchParams(url.hash.split('?')[1]);

  //   if (hashParams.has('month') || hashParams.has('year')) {
  //     // Convert the month name to a number
  //     const yearString = hashParams.get('year') || ''; // Fallback to empty string

  //     const year = parseInt(yearString, 10); // Parse year as an integer
  //     const decodedYear = this._maskedQueryService.decodeParams(hashParams.has('year'))
  //     this.selectedYear = decodedYear;
  //     if (hashParams.has('month')) {
  //       const decodedMonth = this._maskedQueryService.decodeParams(hashParams.has('month'))
  //       const monthName = decodedMonth || ''; // Fallback to empty string
  //       const month = new Date(`${monthName} 1`).getMonth() + 1; // Month in numeric format
  //       this.selectedMonth = month;
  //       this._sharedDataService.selDateInPlanning = new Date(
  //         year,
  //         month - 1,
  //         1
  //       );
  //     }

  //     // Update sharedDataService with URL values
  //   }
  //   else {
  //     // Reset values if no URL params are found
  //     this.selectedMonth = null;
  //     this.selectedYear = null;
  //   }
  //   return { month: this.selectedMonth, year: this.selectedYear };
  // }

  // storeDepartment(departmentId: any) {
  //   // code to add dept id to url param starts
  //   // Add departmentId to the window URL
  //   const url = new URL(window.location.href);
    
  //   const hashPath = url.hash.split('?')[0]; // Preserve base hash path
  //   const hashParams = new URLSearchParams(url.hash.split('?')[1]); 
  //   // console.log('encode url', this._maskedQueryService.encodeParams(url.hash.split('?')));
  //   if (departmentId) {
  //     //  hashParams.set('department', departmentId); // Add or update department parameter
  //     // const newEncoded = this._maskedQueryService.encodeParams(departmentId);
  //     hashParams.set('department', departmentId); // Add or update department parameter
  //   } else {
  //     hashParams.delete('department'); // Remove department parameter if departmentId is undefined
  //   }

  //   const newHash = `${hashPath}?${hashParams.toString()}`;
  //   url.hash = newHash;
  //   console.log('window.loc',url);
  //   // const encodedUrl = this._maskedQueryService.encodeParams(url.toString())
  //   // Update the browser history with the new URL
  //   window.history.replaceState({}, '', url.toString());
  //   // window.history.replaceState({}, '', encodedUrl);
    
  //   // code to add dept to url param ends
  // }
 
  // getDepartment(deptList: any) {
  //   const hashParams = window?.location?.hash.split('?')[1];
  //   const searchParams = hashParams ? new URLSearchParams(hashParams) : null;
  //   if (searchParams?.has('department')) {
  //     const departmentIdFromUrl = searchParams.get('department');
  //     const decodedDeptId = this._maskedQueryService.decodeParams(departmentIdFromUrl)
  //     const matchedDept = deptList.find(
  //       (dept: any) => dept.id === decodedDeptId
  //     );

  //     if (matchedDept) {
  //       this.selectedDepartment = matchedDept.id;
  //       this.selectedDeptData = matchedDept;
  //     } else {
  //       this.selectedDepartment = null; // Handle case where department ID is invalid
  //     }
  //   }
  //   return { id: this.selectedDepartment, data: this.selectedDeptData };
  // }

  // storePlanningView(planningView: any) {
  //   // code to add Planning View to url param starts
  //   // Add Planning View to the window URL
  //   const url = new URL(window.location.href);
  //   const hashPath = url.hash.split('?')[0]; // Preserve base hash path
  //   const hashParams = new URLSearchParams(url.hash.split('?')[1]);
  //   if (planningView) {
  //     const encodedPlanningView = this._maskedQueryService.encodeParams(planningView)
  //     hashParams.set('planningView', planningView); // Add or update planningView parameter
  //   } else {
  //     hashParams.delete('planningView'); // Remove planningView parameter if planningView is undefined
  //   }

  //   const newHash = `${hashPath}?${hashParams.toString()}`;
  //   url.hash = newHash;

  //   // Update the browser history with the new URL
  //   window.history.replaceState({}, '', url.toString());
  //   // code to add dept to url param ends
  // }
  
  // getPlanningView() {
  //   const hashParams = window?.location?.hash.split('?')[1];
  //   const searchParams = hashParams ? new URLSearchParams(hashParams) : null;
  //   if (searchParams?.has('planningView')) {
  //     const decodedPlanningView = this._maskedQueryService.decodeParams(searchParams.get('planningView'))
  //     // const planningViewFromUrl = searchParams.get('planningView');
  //     const planningViewFromUrl = decodedPlanningView;
  //     this.selectedPlanningView = planningViewFromUrl;
  //   }
  //   return this.selectedPlanningView ;
  // }

}
